var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appContainer",class:[_vm.layoutSizeClass, _vm.textColorClass],attrs:{"id":"imot"}},[(_vm.settings.loaded && _vm.filters.loaded && _vm.vehicles.loaded)?_c('router-view'):_c('div',{staticClass:"imot-app-loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }